import { INPUT_FIELD_TYPES } from "./input-field-types.js";
import { COMMON_FIELD_TYPES, CONTACTS_FIELD_TYPES, EVENTS_FIELD_TYPES, PAYMENTS_FIELD_TYPES, QUIZ_FIELD_TYPES, isInputFieldType, isQuizFieldType } from "./input-field-types.js";
import { READONLY_FIELD_TYPES } from "./readonly-field-types.js";
const FIELD_TYPES = {
  ...INPUT_FIELD_TYPES,
  ...READONLY_FIELD_TYPES,
  SUBMIT_BUTTON: "SUBMIT_BUTTON"
};
export {
  COMMON_FIELD_TYPES,
  CONTACTS_FIELD_TYPES,
  EVENTS_FIELD_TYPES,
  FIELD_TYPES,
  INPUT_FIELD_TYPES,
  PAYMENTS_FIELD_TYPES,
  QUIZ_FIELD_TYPES,
  READONLY_FIELD_TYPES,
  isInputFieldType,
  isQuizFieldType
};
//# sourceMappingURL=field-types.js.map
